module.exports = __webpack_public_path__ + "media/fonts/MonumentExtended-Regular-db74f7a563ec017311bc7a57573e2497.otf";